var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 73C56.8823 73 73 56.8823 73 37C73 17.1178 56.8823 1 37 1C17.1178 1 1 17.1178 1 37C1 56.8823 17.1178 73 37 73Z",
    fill: "#006D77",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2772 27.7855H43.5859C43.8903 27.7855 44.1373 27.5527 44.1373 27.2658V24.148C44.1373 23.8612 43.8903 23.6284 43.5859 23.6284H40.2772C36.9333 23.6284 34.2114 26.1923 34.2114 29.3443V32.9818H30.3512C30.0469 32.9818 29.7998 33.2146 29.7998 33.5014V36.6192C29.7998 36.906 30.0469 37.1388 30.3512 37.1388H34.2114V48.051C34.2114 48.3379 34.4584 48.5707 34.7628 48.5707H38.0715C38.3759 48.5707 38.6229 48.3379 38.6229 48.051V37.1388H42.483C42.7201 37.1388 42.9308 36.9954 43.0069 36.7834L44.1098 33.6656C44.166 33.5076 44.1374 33.333 44.0337 33.1969C43.9289 33.0618 43.7635 32.9818 43.5859 32.9818H38.6229V29.3443C38.6229 28.4849 39.3652 27.7855 40.2772 27.7855Z",
    fill: "#83C5BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookGreen);
export default __webpack_public_path__ + "static/media/facebook_green.80119701d0c9a2edd5abf271098ae8cb.svg";
export { ForwardRef as ReactComponent };